export const apiService = {
  search,
  count,
  marker,
};

/**
 * search
 * @returns {Promise<any>}
 */
function search(search, regions) {
  const opts = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ search, regions }),
  };
  return fetch("/postwurfspezial/index/search", opts)
    .catch(handleError)
    .then(checkStatus)
    .then(parseJSON);
}

/**
 * count
 * @returns {Promise<Response>}
 */
function count(product, regions) {
  const opts = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ product, regions }),
  };
  return fetch("/postwurfspezial/index/count", opts)
    .catch(handleError)
    .then(checkStatus)
    .then(parseJSON);
}

/**
 * Marker
 * @param lat
 * @param lng
 * @param boundingBox
 * @returns {Promise<Response>}
 */
function marker(lat, lng, boundingBox) {
  const payload = {
    location: {
      lat,
      lng,
    },
    map: {
      boundingBox,
    },
  };
  const opts = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(payload),
  };
  return fetch("/postaktuell/index/markers", opts)
    .catch(handleError)
    .then(checkStatus)
    .then(parseJSON);
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////
// Helper functions
/////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Handle network issues
 */
const handleError = (error) => {
  error.response = {
    status: 0,
    statusText:
      "Cannot connect. Please make sure you are connected to internet.",
  };
  throw error;
};

/**
 * Check API response
 */
const checkStatus = (response) => {
  if (response.ok) {
    return response;
  }

  return response
    .json()
    .then((json) => {
      // Try to decode a JSON response from api call
      return Promise.reject({
        status: response.status,
        ok: false,
        statusText: response.statusText,
        body: json,
      });
    })
    .catch((error) => {
      // return API error without JSON data
      return Promise.reject({
        status: response.status,
        ok: false,
        statusText: response.statusText,
        body: response.body,
        error,
      });
    });
};

/**
 * Handle JSON data or NO-CONTENT (status 204|205)
 */
const parseJSON = (response) => {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
};
